module.exports = __webpack_public_path__ + "media/tb related lesion.69a0b1ad.wav";